module.exports = __webpack_public_path__ + "static/media/allgaier-tumbler-sito-s.dd41865c.jpg";